import { useState } from 'react';
import { XIcon } from '@heroicons/react/outline';
import { TabLabelWrapper, TabLabel, CloseTab } from '@styles/StyledTabs';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle';
import { TabContextMenu } from './TabContextMenu';

interface ITabProps {
  index: number;
  title: string;
  isActive:boolean;
  onCopy(tabIndex: number): void;
  onClose(tabIndex: number): void;
  onCloseLeft(tabIndex: number): void;
  onCloseRight(tabIndex: number): void;
  onCloseAll(): void;
}

export const GlobalTabLabel = ({ index, title, isActive, onCopy, onClose, onCloseLeft, onCloseRight, onCloseAll }: ITabProps) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  useDocumentTitle(isActive ? title : '');

  const handleContextMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  const handleCopy = (event: React.MouseEvent) => {
    event.stopPropagation();
    onCopy(index);
    setOpen(false);
  };

  const handleClose = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClose(index);
    setOpen(false);
  };

  const handleCloseLeft = (event: React.MouseEvent) => {
    event.stopPropagation();
    onCloseLeft(index);
    setOpen(false);
  };

  const handleCloseRight = (event: React.MouseEvent) => {
    event.stopPropagation();
    onCloseRight(index);
    setOpen(false);
  };

  const handleCloseAll = (event: React.MouseEvent) => {
    event.stopPropagation();
    onCloseAll();
    setOpen(false);
  };

  return (
    <TabLabelWrapper>
      <TabLabel onContextMenu={handleContextMenu}>
        {title}

        <CloseTab onClick={handleClose}>
          <XIcon width={14} />
        </CloseTab>
      </TabLabel>

      <TabContextMenu
        open={open}
        anchorEl={anchorEl}
        setOpen={setOpen}
        onCopy={handleCopy}
        onClose={handleClose}
        onCloseLeft={handleCloseLeft}
        onCloseRight={handleCloseRight}
        onCloseAll={handleCloseAll}
      />
    </TabLabelWrapper>
  );
};
